<script>
import { mapActions, mapGetters } from 'vuex'
import { TYPES as SUPPLIER_CONTACT_TYPES } from './store'
import { TYPES as CNT_ORG_TYPES } from '../../../organization-contact/store'
import { ROUTES as SUPPLIER_ORG_ROUTES } from '../../../organization/organization/supplier-organization/router'
import { ROUTES as SUPPLIER_CONTACT_ROUTES } from './router'
import { ORGANIZATION_SUPPLIER_TYPE_CODE } from '@/const'

import ContactDetailMixin from '../../../components/contact/mixins/ContactDetailMixin'

export default {
  name: 'SupplierContactDetail',
  mixins: [ContactDetailMixin],
  data () {
    return {
      SUPPLIER_ORG_ROUTES,
      SUPPLIER_CONTACT_ROUTES,
      organizationTitle: 'Supplier organization',
      routeNameOrganizationDetail: SUPPLIER_ORG_ROUTES.SUPPLIER_ORGANIZATION_DETAIL,
      title: 'Supplier contact',
      titleList: 'Supplier contacts',
      orgType: ORGANIZATION_SUPPLIER_TYPE_CODE
    }
  },
  computed: {
    ...mapGetters({
      ...SUPPLIER_CONTACT_TYPES.GENERIC.organization.suppliercontact.DETAIL.GETTERS
    })
  },
  methods: {
    ...mapActions({
      ...SUPPLIER_CONTACT_TYPES.GENERIC.organization.suppliercontact.DETAIL.ACTIONS,
      getContactList: SUPPLIER_CONTACT_TYPES.GENERIC.organization.suppliercontact.LIST.ACTIONS.getList,
      createOrganizationContact: CNT_ORG_TYPES.GENERIC.organization.organizationcontact.DETAIL.ACTIONS.create
    }),
    goToOrganizationDetail () {
      this.$router.push({ name: SUPPLIER_ORG_ROUTES.SUPPLIER_ORGANIZATION_DETAIL, params: { id: this.$route.params.id } })
    },
    goToList () {
      this.$router.push({ name: SUPPLIER_CONTACT_ROUTES.SUPPLIER_CONTACT_LIST })
    }
  }
}
</script>
